// Single source of truth for the UI-only admin allow-list.
//
// IMPORTANT: this check is purely cosmetic — it gates what the nav bar shows
// and nothing else. Real authorization lives on the backend: admin endpoints
// reject non-admin tokens regardless of what the client thinks. This file
// exists so the list isn't duplicated across four components when we eventually
// replace it with a server-driven `isAdmin` field on the sign-in response.
export const ADMIN_EMAILS: ReadonlyArray<string> = ["ibai.ros@hotmail.com"];

export const isAdminEmail = (email: string | undefined | null): boolean =>
    !!email && ADMIN_EMAILS.includes(email);
